/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AuthOtpResponse as ModelsAuthenticationAuthOtpResponse } from '../models/Models/Authentication/auth-otp-response';
import { CustomerAccountsResponse as ModelsCustomerCustomerAccountsResponse } from '../models/Models/Customer/customer-accounts-response';
import { CustomerDetailsResponse as ModelsCustomerCustomerDetailsResponse } from '../models/Models/Customer/customer-details-response';
import { CustomerEnquiry as ModelsCustomerCustomerEnquiry } from '../models/Models/Customer/customer-enquiry';
import { CustomerNotification as ModelsCustomerCustomerNotification } from '../models/Models/Customer/customer-notification';
import { CustomerNotificationResponse as ModelsCustomerCustomerNotificationResponse } from '../models/Models/Customer/customer-notification-response';
import { CustomerNotificationsResponse as ModelsCustomerCustomerNotificationsResponse } from '../models/Models/Customer/customer-notifications-response';
import { CustomerOnlinePaymentResponse as ModelsCustomerCustomerOnlinePaymentResponse } from '../models/Models/Customer/customer-online-payment-response';
import { CustomerOnlinePaymentsResponse as ModelsCustomerCustomerOnlinePaymentsResponse } from '../models/Models/Customer/customer-online-payments-response';
import { CustomerOnlinePaymentTypesResponse as ModelsCustomerCustomerOnlinePaymentTypesResponse } from '../models/Models/Customer/customer-online-payment-types-response';
import { CustomerScheduledPaymentsResponse as ModelsCustomerCustomerScheduledPaymentsResponse } from '../models/Models/Customer/customer-scheduled-payments-response';
import { CustomerOnlinePaymentStatusEnum as ModelsCustomerEnumsCustomerOnlinePaymentStatusEnum } from '../models/Models/Customer/Enums/customer-online-payment-status-enum';
import { v3CustomersMeAccountsAccountNumberGet$Json } from '../fn/customers/v-3-customers-me-accounts-account-number-get-json';
import { V3CustomersMeAccountsAccountNumberGet$Json$Params } from '../fn/customers/v-3-customers-me-accounts-account-number-get-json';
import { v3CustomersMeAccountsAccountNumberGet$Plain } from '../fn/customers/v-3-customers-me-accounts-account-number-get-plain';
import { V3CustomersMeAccountsAccountNumberGet$Plain$Params } from '../fn/customers/v-3-customers-me-accounts-account-number-get-plain';
import { v3CustomersMeAccountsAccountNumberGet$Xml } from '../fn/customers/v-3-customers-me-accounts-account-number-get-xml';
import { V3CustomersMeAccountsAccountNumberGet$Xml$Params } from '../fn/customers/v-3-customers-me-accounts-account-number-get-xml';
import { v3CustomersMeAccountsAccountNumberPaymentsGet$Json } from '../fn/customers/v-3-customers-me-accounts-account-number-payments-get-json';
import { V3CustomersMeAccountsAccountNumberPaymentsGet$Json$Params } from '../fn/customers/v-3-customers-me-accounts-account-number-payments-get-json';
import { v3CustomersMeAccountsAccountNumberPaymentsGet$Plain } from '../fn/customers/v-3-customers-me-accounts-account-number-payments-get-plain';
import { V3CustomersMeAccountsAccountNumberPaymentsGet$Plain$Params } from '../fn/customers/v-3-customers-me-accounts-account-number-payments-get-plain';
import { v3CustomersMeAccountsAccountNumberPaymentsGet$Xml } from '../fn/customers/v-3-customers-me-accounts-account-number-payments-get-xml';
import { V3CustomersMeAccountsAccountNumberPaymentsGet$Xml$Params } from '../fn/customers/v-3-customers-me-accounts-account-number-payments-get-xml';
import { v3CustomersMeDetailsGet$Json } from '../fn/customers/v-3-customers-me-details-get-json';
import { V3CustomersMeDetailsGet$Json$Params } from '../fn/customers/v-3-customers-me-details-get-json';
import { v3CustomersMeDetailsGet$Plain } from '../fn/customers/v-3-customers-me-details-get-plain';
import { V3CustomersMeDetailsGet$Plain$Params } from '../fn/customers/v-3-customers-me-details-get-plain';
import { v3CustomersMeDetailsGet$Xml } from '../fn/customers/v-3-customers-me-details-get-xml';
import { V3CustomersMeDetailsGet$Xml$Params } from '../fn/customers/v-3-customers-me-details-get-xml';
import { v3CustomersMeDetailsOtpGet$Json } from '../fn/customers/v-3-customers-me-details-otp-get-json';
import { V3CustomersMeDetailsOtpGet$Json$Params } from '../fn/customers/v-3-customers-me-details-otp-get-json';
import { v3CustomersMeDetailsOtpGet$Plain } from '../fn/customers/v-3-customers-me-details-otp-get-plain';
import { V3CustomersMeDetailsOtpGet$Plain$Params } from '../fn/customers/v-3-customers-me-details-otp-get-plain';
import { v3CustomersMeDetailsOtpGet$Xml } from '../fn/customers/v-3-customers-me-details-otp-get-xml';
import { V3CustomersMeDetailsOtpGet$Xml$Params } from '../fn/customers/v-3-customers-me-details-otp-get-xml';
import { v3CustomersMeDetailsPatch$Json$Json } from '../fn/customers/v-3-customers-me-details-patch-json-json';
import { V3CustomersMeDetailsPatch$Json$Json$Params } from '../fn/customers/v-3-customers-me-details-patch-json-json';
import { v3CustomersMeDetailsPatch$Json$Plain } from '../fn/customers/v-3-customers-me-details-patch-json-plain';
import { V3CustomersMeDetailsPatch$Json$Plain$Params } from '../fn/customers/v-3-customers-me-details-patch-json-plain';
import { v3CustomersMeDetailsPatch$Json$Xml } from '../fn/customers/v-3-customers-me-details-patch-json-xml';
import { V3CustomersMeDetailsPatch$Json$Xml$Params } from '../fn/customers/v-3-customers-me-details-patch-json-xml';
import { v3CustomersMeDetailsPatch$Xml$Json } from '../fn/customers/v-3-customers-me-details-patch-xml-json';
import { V3CustomersMeDetailsPatch$Xml$Json$Params } from '../fn/customers/v-3-customers-me-details-patch-xml-json';
import { v3CustomersMeDetailsPatch$Xml$Plain } from '../fn/customers/v-3-customers-me-details-patch-xml-plain';
import { V3CustomersMeDetailsPatch$Xml$Plain$Params } from '../fn/customers/v-3-customers-me-details-patch-xml-plain';
import { v3CustomersMeDetailsPatch$Xml$Xml } from '../fn/customers/v-3-customers-me-details-patch-xml-xml';
import { V3CustomersMeDetailsPatch$Xml$Xml$Params } from '../fn/customers/v-3-customers-me-details-patch-xml-xml';
import { v3CustomersMeDetailsPut$Json$Json } from '../fn/customers/v-3-customers-me-details-put-json-json';
import { V3CustomersMeDetailsPut$Json$Json$Params } from '../fn/customers/v-3-customers-me-details-put-json-json';
import { v3CustomersMeDetailsPut$Json$Plain } from '../fn/customers/v-3-customers-me-details-put-json-plain';
import { V3CustomersMeDetailsPut$Json$Plain$Params } from '../fn/customers/v-3-customers-me-details-put-json-plain';
import { v3CustomersMeDetailsPut$Json$Xml } from '../fn/customers/v-3-customers-me-details-put-json-xml';
import { V3CustomersMeDetailsPut$Json$Xml$Params } from '../fn/customers/v-3-customers-me-details-put-json-xml';
import { v3CustomersMeDetailsPut$Xml$Json } from '../fn/customers/v-3-customers-me-details-put-xml-json';
import { V3CustomersMeDetailsPut$Xml$Json$Params } from '../fn/customers/v-3-customers-me-details-put-xml-json';
import { v3CustomersMeDetailsPut$Xml$Plain } from '../fn/customers/v-3-customers-me-details-put-xml-plain';
import { V3CustomersMeDetailsPut$Xml$Plain$Params } from '../fn/customers/v-3-customers-me-details-put-xml-plain';
import { v3CustomersMeDetailsPut$Xml$Xml } from '../fn/customers/v-3-customers-me-details-put-xml-xml';
import { V3CustomersMeDetailsPut$Xml$Xml$Params } from '../fn/customers/v-3-customers-me-details-put-xml-xml';
import { v3CustomersMeEnquiryPost$Json$Json } from '../fn/customers/v-3-customers-me-enquiry-post-json-json';
import { V3CustomersMeEnquiryPost$Json$Json$Params } from '../fn/customers/v-3-customers-me-enquiry-post-json-json';
import { v3CustomersMeEnquiryPost$Json$Plain } from '../fn/customers/v-3-customers-me-enquiry-post-json-plain';
import { V3CustomersMeEnquiryPost$Json$Plain$Params } from '../fn/customers/v-3-customers-me-enquiry-post-json-plain';
import { v3CustomersMeEnquiryPost$Json$Xml } from '../fn/customers/v-3-customers-me-enquiry-post-json-xml';
import { V3CustomersMeEnquiryPost$Json$Xml$Params } from '../fn/customers/v-3-customers-me-enquiry-post-json-xml';
import { v3CustomersMeEnquiryPost$Xml$Json } from '../fn/customers/v-3-customers-me-enquiry-post-xml-json';
import { V3CustomersMeEnquiryPost$Xml$Json$Params } from '../fn/customers/v-3-customers-me-enquiry-post-xml-json';
import { v3CustomersMeEnquiryPost$Xml$Plain } from '../fn/customers/v-3-customers-me-enquiry-post-xml-plain';
import { V3CustomersMeEnquiryPost$Xml$Plain$Params } from '../fn/customers/v-3-customers-me-enquiry-post-xml-plain';
import { v3CustomersMeEnquiryPost$Xml$Xml } from '../fn/customers/v-3-customers-me-enquiry-post-xml-xml';
import { V3CustomersMeEnquiryPost$Xml$Xml$Params } from '../fn/customers/v-3-customers-me-enquiry-post-xml-xml';
import { v3CustomersMeNotificationsGet$Json } from '../fn/customers/v-3-customers-me-notifications-get-json';
import { V3CustomersMeNotificationsGet$Json$Params } from '../fn/customers/v-3-customers-me-notifications-get-json';
import { v3CustomersMeNotificationsGet$Plain } from '../fn/customers/v-3-customers-me-notifications-get-plain';
import { V3CustomersMeNotificationsGet$Plain$Params } from '../fn/customers/v-3-customers-me-notifications-get-plain';
import { v3CustomersMeNotificationsGet$Xml } from '../fn/customers/v-3-customers-me-notifications-get-xml';
import { V3CustomersMeNotificationsGet$Xml$Params } from '../fn/customers/v-3-customers-me-notifications-get-xml';
import { v3CustomersMeNotificationsNotificationIdDelete$Json } from '../fn/customers/v-3-customers-me-notifications-notification-id-delete-json';
import { V3CustomersMeNotificationsNotificationIdDelete$Json$Params } from '../fn/customers/v-3-customers-me-notifications-notification-id-delete-json';
import { v3CustomersMeNotificationsNotificationIdDelete$Plain } from '../fn/customers/v-3-customers-me-notifications-notification-id-delete-plain';
import { V3CustomersMeNotificationsNotificationIdDelete$Plain$Params } from '../fn/customers/v-3-customers-me-notifications-notification-id-delete-plain';
import { v3CustomersMeNotificationsNotificationIdDelete$Xml } from '../fn/customers/v-3-customers-me-notifications-notification-id-delete-xml';
import { V3CustomersMeNotificationsNotificationIdDelete$Xml$Params } from '../fn/customers/v-3-customers-me-notifications-notification-id-delete-xml';
import { v3CustomersMeNotificationsNotificationIdGet$Json } from '../fn/customers/v-3-customers-me-notifications-notification-id-get-json';
import { V3CustomersMeNotificationsNotificationIdGet$Json$Params } from '../fn/customers/v-3-customers-me-notifications-notification-id-get-json';
import { v3CustomersMeNotificationsNotificationIdGet$Plain } from '../fn/customers/v-3-customers-me-notifications-notification-id-get-plain';
import { V3CustomersMeNotificationsNotificationIdGet$Plain$Params } from '../fn/customers/v-3-customers-me-notifications-notification-id-get-plain';
import { v3CustomersMeNotificationsNotificationIdGet$Xml } from '../fn/customers/v-3-customers-me-notifications-notification-id-get-xml';
import { V3CustomersMeNotificationsNotificationIdGet$Xml$Params } from '../fn/customers/v-3-customers-me-notifications-notification-id-get-xml';
import { v3CustomersMeNotificationsNotificationIdReadStatusPatch$Json } from '../fn/customers/v-3-customers-me-notifications-notification-id-read-status-patch-json';
import { V3CustomersMeNotificationsNotificationIdReadStatusPatch$Json$Params } from '../fn/customers/v-3-customers-me-notifications-notification-id-read-status-patch-json';
import { v3CustomersMeNotificationsNotificationIdReadStatusPatch$Plain } from '../fn/customers/v-3-customers-me-notifications-notification-id-read-status-patch-plain';
import { V3CustomersMeNotificationsNotificationIdReadStatusPatch$Plain$Params } from '../fn/customers/v-3-customers-me-notifications-notification-id-read-status-patch-plain';
import { v3CustomersMeNotificationsNotificationIdReadStatusPatch$Xml } from '../fn/customers/v-3-customers-me-notifications-notification-id-read-status-patch-xml';
import { V3CustomersMeNotificationsNotificationIdReadStatusPatch$Xml$Params } from '../fn/customers/v-3-customers-me-notifications-notification-id-read-status-patch-xml';
import { v3CustomersMeNotificationsPatch$Json } from '../fn/customers/v-3-customers-me-notifications-patch-json';
import { V3CustomersMeNotificationsPatch$Json$Params } from '../fn/customers/v-3-customers-me-notifications-patch-json';
import { v3CustomersMeNotificationsPatch$Plain } from '../fn/customers/v-3-customers-me-notifications-patch-plain';
import { V3CustomersMeNotificationsPatch$Plain$Params } from '../fn/customers/v-3-customers-me-notifications-patch-plain';
import { v3CustomersMeNotificationsPatch$Xml } from '../fn/customers/v-3-customers-me-notifications-patch-xml';
import { V3CustomersMeNotificationsPatch$Xml$Params } from '../fn/customers/v-3-customers-me-notifications-patch-xml';
import { v3CustomersMeNotificationsUnreadGet$Json } from '../fn/customers/v-3-customers-me-notifications-unread-get-json';
import { V3CustomersMeNotificationsUnreadGet$Json$Params } from '../fn/customers/v-3-customers-me-notifications-unread-get-json';
import { v3CustomersMeNotificationsUnreadGet$Plain } from '../fn/customers/v-3-customers-me-notifications-unread-get-plain';
import { V3CustomersMeNotificationsUnreadGet$Plain$Params } from '../fn/customers/v-3-customers-me-notifications-unread-get-plain';
import { v3CustomersMeNotificationsUnreadGet$Xml } from '../fn/customers/v-3-customers-me-notifications-unread-get-xml';
import { V3CustomersMeNotificationsUnreadGet$Xml$Params } from '../fn/customers/v-3-customers-me-notifications-unread-get-xml';
import { v3CustomersMeOnlinePaymentsGet$Json } from '../fn/customers/v-3-customers-me-online-payments-get-json';
import { V3CustomersMeOnlinePaymentsGet$Json$Params } from '../fn/customers/v-3-customers-me-online-payments-get-json';
import { v3CustomersMeOnlinePaymentsGet$Plain } from '../fn/customers/v-3-customers-me-online-payments-get-plain';
import { V3CustomersMeOnlinePaymentsGet$Plain$Params } from '../fn/customers/v-3-customers-me-online-payments-get-plain';
import { v3CustomersMeOnlinePaymentsGet$Xml } from '../fn/customers/v-3-customers-me-online-payments-get-xml';
import { V3CustomersMeOnlinePaymentsGet$Xml$Params } from '../fn/customers/v-3-customers-me-online-payments-get-xml';
import { v3CustomersMeOnlinePaymentsIdGet$Json } from '../fn/customers/v-3-customers-me-online-payments-id-get-json';
import { V3CustomersMeOnlinePaymentsIdGet$Json$Params } from '../fn/customers/v-3-customers-me-online-payments-id-get-json';
import { v3CustomersMeOnlinePaymentsIdGet$Plain } from '../fn/customers/v-3-customers-me-online-payments-id-get-plain';
import { V3CustomersMeOnlinePaymentsIdGet$Plain$Params } from '../fn/customers/v-3-customers-me-online-payments-id-get-plain';
import { v3CustomersMeOnlinePaymentsIdGet$Xml } from '../fn/customers/v-3-customers-me-online-payments-id-get-xml';
import { V3CustomersMeOnlinePaymentsIdGet$Xml$Params } from '../fn/customers/v-3-customers-me-online-payments-id-get-xml';
import { v3CustomersMeOnlinePaymentsIdStatusGet$Json } from '../fn/customers/v-3-customers-me-online-payments-id-status-get-json';
import { V3CustomersMeOnlinePaymentsIdStatusGet$Json$Params } from '../fn/customers/v-3-customers-me-online-payments-id-status-get-json';
import { v3CustomersMeOnlinePaymentsIdStatusGet$Plain } from '../fn/customers/v-3-customers-me-online-payments-id-status-get-plain';
import { V3CustomersMeOnlinePaymentsIdStatusGet$Plain$Params } from '../fn/customers/v-3-customers-me-online-payments-id-status-get-plain';
import { v3CustomersMeOnlinePaymentsIdStatusGet$Xml } from '../fn/customers/v-3-customers-me-online-payments-id-status-get-xml';
import { V3CustomersMeOnlinePaymentsIdStatusGet$Xml$Params } from '../fn/customers/v-3-customers-me-online-payments-id-status-get-xml';
import { v3CustomersMeOnlinePaymentsPost$Json$Json } from '../fn/customers/v-3-customers-me-online-payments-post-json-json';
import { V3CustomersMeOnlinePaymentsPost$Json$Json$Params } from '../fn/customers/v-3-customers-me-online-payments-post-json-json';
import { v3CustomersMeOnlinePaymentsPost$Json$Plain } from '../fn/customers/v-3-customers-me-online-payments-post-json-plain';
import { V3CustomersMeOnlinePaymentsPost$Json$Plain$Params } from '../fn/customers/v-3-customers-me-online-payments-post-json-plain';
import { v3CustomersMeOnlinePaymentsPost$Json$Xml } from '../fn/customers/v-3-customers-me-online-payments-post-json-xml';
import { V3CustomersMeOnlinePaymentsPost$Json$Xml$Params } from '../fn/customers/v-3-customers-me-online-payments-post-json-xml';
import { v3CustomersMeOnlinePaymentsPost$Xml$Json } from '../fn/customers/v-3-customers-me-online-payments-post-xml-json';
import { V3CustomersMeOnlinePaymentsPost$Xml$Json$Params } from '../fn/customers/v-3-customers-me-online-payments-post-xml-json';
import { v3CustomersMeOnlinePaymentsPost$Xml$Plain } from '../fn/customers/v-3-customers-me-online-payments-post-xml-plain';
import { V3CustomersMeOnlinePaymentsPost$Xml$Plain$Params } from '../fn/customers/v-3-customers-me-online-payments-post-xml-plain';
import { v3CustomersMeOnlinePaymentsPost$Xml$Xml } from '../fn/customers/v-3-customers-me-online-payments-post-xml-xml';
import { V3CustomersMeOnlinePaymentsPost$Xml$Xml$Params } from '../fn/customers/v-3-customers-me-online-payments-post-xml-xml';
import { v3CustomersMeOnlinePaymentTypesGet$Json } from '../fn/customers/v-3-customers-me-online-payment-types-get-json';
import { V3CustomersMeOnlinePaymentTypesGet$Json$Params } from '../fn/customers/v-3-customers-me-online-payment-types-get-json';
import { v3CustomersMeOnlinePaymentTypesGet$Plain } from '../fn/customers/v-3-customers-me-online-payment-types-get-plain';
import { V3CustomersMeOnlinePaymentTypesGet$Plain$Params } from '../fn/customers/v-3-customers-me-online-payment-types-get-plain';
import { v3CustomersMeOnlinePaymentTypesGet$Xml } from '../fn/customers/v-3-customers-me-online-payment-types-get-xml';
import { V3CustomersMeOnlinePaymentTypesGet$Xml$Params } from '../fn/customers/v-3-customers-me-online-payment-types-get-xml';
import { v3CustomersMePaymentsGet$Json } from '../fn/customers/v-3-customers-me-payments-get-json';
import { V3CustomersMePaymentsGet$Json$Params } from '../fn/customers/v-3-customers-me-payments-get-json';
import { v3CustomersMePaymentsGet$Plain } from '../fn/customers/v-3-customers-me-payments-get-plain';
import { V3CustomersMePaymentsGet$Plain$Params } from '../fn/customers/v-3-customers-me-payments-get-plain';
import { v3CustomersMePaymentsGet$Xml } from '../fn/customers/v-3-customers-me-payments-get-xml';
import { V3CustomersMePaymentsGet$Xml$Params } from '../fn/customers/v-3-customers-me-payments-get-xml';
import { v3CustomersMePingGet$Json } from '../fn/customers/v-3-customers-me-ping-get-json';
import { V3CustomersMePingGet$Json$Params } from '../fn/customers/v-3-customers-me-ping-get-json';
import { v3CustomersMePingGet$Plain } from '../fn/customers/v-3-customers-me-ping-get-plain';
import { V3CustomersMePingGet$Plain$Params } from '../fn/customers/v-3-customers-me-ping-get-plain';
import { v3CustomersMePingGet$Xml } from '../fn/customers/v-3-customers-me-ping-get-xml';
import { V3CustomersMePingGet$Xml$Params } from '../fn/customers/v-3-customers-me-ping-get-xml';

@Injectable({ providedIn: 'root' })
export class CustomersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `v3CustomersMePingGet()` */
  static readonly V3CustomersMePingGetPath = '/v3/customers/me/ping';

  /**
   * Authenticated Ping - returns 1 if authenticated and with customer portal role.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMePingGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMePingGet$Plain$Response(params?: V3CustomersMePingGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return v3CustomersMePingGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Authenticated Ping - returns 1 if authenticated and with customer portal role.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMePingGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMePingGet$Plain(params?: V3CustomersMePingGet$Plain$Params, context?: HttpContext): Observable<string> {
    return this.v3CustomersMePingGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /**
   * Authenticated Ping - returns 1 if authenticated and with customer portal role.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMePingGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMePingGet$Json$Response(params?: V3CustomersMePingGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return v3CustomersMePingGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Authenticated Ping - returns 1 if authenticated and with customer portal role.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMePingGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMePingGet$Json(params?: V3CustomersMePingGet$Json$Params, context?: HttpContext): Observable<string> {
    return this.v3CustomersMePingGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /**
   * Authenticated Ping - returns 1 if authenticated and with customer portal role.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMePingGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMePingGet$Xml$Response(params?: V3CustomersMePingGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return v3CustomersMePingGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Authenticated Ping - returns 1 if authenticated and with customer portal role.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMePingGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMePingGet$Xml(params?: V3CustomersMePingGet$Xml$Params, context?: HttpContext): Observable<string> {
    return this.v3CustomersMePingGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `v3CustomersMeDetailsGet()` */
  static readonly V3CustomersMeDetailsGetPath = '/v3/customers/me/details';

  /**
   * Gets the details belonging to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeDetailsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeDetailsGet$Plain$Response(params?: V3CustomersMeDetailsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>> {
    return v3CustomersMeDetailsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the details belonging to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeDetailsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeDetailsGet$Plain(params?: V3CustomersMeDetailsGet$Plain$Params, context?: HttpContext): Observable<ModelsCustomerCustomerDetailsResponse> {
    return this.v3CustomersMeDetailsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>): ModelsCustomerCustomerDetailsResponse => r.body)
    );
  }

  /**
   * Gets the details belonging to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeDetailsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeDetailsGet$Json$Response(params?: V3CustomersMeDetailsGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>> {
    return v3CustomersMeDetailsGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the details belonging to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeDetailsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeDetailsGet$Json(params?: V3CustomersMeDetailsGet$Json$Params, context?: HttpContext): Observable<ModelsCustomerCustomerDetailsResponse> {
    return this.v3CustomersMeDetailsGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>): ModelsCustomerCustomerDetailsResponse => r.body)
    );
  }

  /**
   * Gets the details belonging to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeDetailsGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeDetailsGet$Xml$Response(params?: V3CustomersMeDetailsGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>> {
    return v3CustomersMeDetailsGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the details belonging to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeDetailsGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeDetailsGet$Xml(params?: V3CustomersMeDetailsGet$Xml$Params, context?: HttpContext): Observable<ModelsCustomerCustomerDetailsResponse> {
    return this.v3CustomersMeDetailsGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>): ModelsCustomerCustomerDetailsResponse => r.body)
    );
  }

  /** Path part for operation `v3CustomersMeDetailsPut()` */
  static readonly V3CustomersMeDetailsPutPath = '/v3/customers/me/details';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeDetailsPut$Json$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3CustomersMeDetailsPut$Json$Plain$Response(params?: V3CustomersMeDetailsPut$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>> {
    return v3CustomersMeDetailsPut$Json$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeDetailsPut$Json$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3CustomersMeDetailsPut$Json$Plain(params?: V3CustomersMeDetailsPut$Json$Plain$Params, context?: HttpContext): Observable<ModelsCustomerCustomerDetailsResponse> {
    return this.v3CustomersMeDetailsPut$Json$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>): ModelsCustomerCustomerDetailsResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeDetailsPut$Json$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3CustomersMeDetailsPut$Json$Json$Response(params?: V3CustomersMeDetailsPut$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>> {
    return v3CustomersMeDetailsPut$Json$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeDetailsPut$Json$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3CustomersMeDetailsPut$Json$Json(params?: V3CustomersMeDetailsPut$Json$Json$Params, context?: HttpContext): Observable<ModelsCustomerCustomerDetailsResponse> {
    return this.v3CustomersMeDetailsPut$Json$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>): ModelsCustomerCustomerDetailsResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeDetailsPut$Json$Xml()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3CustomersMeDetailsPut$Json$Xml$Response(params?: V3CustomersMeDetailsPut$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>> {
    return v3CustomersMeDetailsPut$Json$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeDetailsPut$Json$Xml$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3CustomersMeDetailsPut$Json$Xml(params?: V3CustomersMeDetailsPut$Json$Xml$Params, context?: HttpContext): Observable<ModelsCustomerCustomerDetailsResponse> {
    return this.v3CustomersMeDetailsPut$Json$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>): ModelsCustomerCustomerDetailsResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeDetailsPut$Xml$Plain()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3CustomersMeDetailsPut$Xml$Plain$Response(params?: V3CustomersMeDetailsPut$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>> {
    return v3CustomersMeDetailsPut$Xml$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeDetailsPut$Xml$Plain$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3CustomersMeDetailsPut$Xml$Plain(params?: V3CustomersMeDetailsPut$Xml$Plain$Params, context?: HttpContext): Observable<ModelsCustomerCustomerDetailsResponse> {
    return this.v3CustomersMeDetailsPut$Xml$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>): ModelsCustomerCustomerDetailsResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeDetailsPut$Xml$Json()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3CustomersMeDetailsPut$Xml$Json$Response(params?: V3CustomersMeDetailsPut$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>> {
    return v3CustomersMeDetailsPut$Xml$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeDetailsPut$Xml$Json$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3CustomersMeDetailsPut$Xml$Json(params?: V3CustomersMeDetailsPut$Xml$Json$Params, context?: HttpContext): Observable<ModelsCustomerCustomerDetailsResponse> {
    return this.v3CustomersMeDetailsPut$Xml$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>): ModelsCustomerCustomerDetailsResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeDetailsPut$Xml$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3CustomersMeDetailsPut$Xml$Xml$Response(params?: V3CustomersMeDetailsPut$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>> {
    return v3CustomersMeDetailsPut$Xml$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeDetailsPut$Xml$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3CustomersMeDetailsPut$Xml$Xml(params?: V3CustomersMeDetailsPut$Xml$Xml$Params, context?: HttpContext): Observable<ModelsCustomerCustomerDetailsResponse> {
    return this.v3CustomersMeDetailsPut$Xml$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>): ModelsCustomerCustomerDetailsResponse => r.body)
    );
  }

  /** Path part for operation `v3CustomersMeDetailsPatch()` */
  static readonly V3CustomersMeDetailsPatchPath = '/v3/customers/me/details';

  /**
   * SaveCustomerSettings.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeDetailsPatch$Json$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3CustomersMeDetailsPatch$Json$Plain$Response(params?: V3CustomersMeDetailsPatch$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>> {
    return v3CustomersMeDetailsPatch$Json$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * SaveCustomerSettings.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeDetailsPatch$Json$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3CustomersMeDetailsPatch$Json$Plain(params?: V3CustomersMeDetailsPatch$Json$Plain$Params, context?: HttpContext): Observable<ModelsCustomerCustomerDetailsResponse> {
    return this.v3CustomersMeDetailsPatch$Json$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>): ModelsCustomerCustomerDetailsResponse => r.body)
    );
  }

  /**
   * SaveCustomerSettings.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeDetailsPatch$Json$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3CustomersMeDetailsPatch$Json$Json$Response(params?: V3CustomersMeDetailsPatch$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>> {
    return v3CustomersMeDetailsPatch$Json$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * SaveCustomerSettings.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeDetailsPatch$Json$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3CustomersMeDetailsPatch$Json$Json(params?: V3CustomersMeDetailsPatch$Json$Json$Params, context?: HttpContext): Observable<ModelsCustomerCustomerDetailsResponse> {
    return this.v3CustomersMeDetailsPatch$Json$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>): ModelsCustomerCustomerDetailsResponse => r.body)
    );
  }

  /**
   * SaveCustomerSettings.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeDetailsPatch$Json$Xml()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3CustomersMeDetailsPatch$Json$Xml$Response(params?: V3CustomersMeDetailsPatch$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>> {
    return v3CustomersMeDetailsPatch$Json$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * SaveCustomerSettings.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeDetailsPatch$Json$Xml$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3CustomersMeDetailsPatch$Json$Xml(params?: V3CustomersMeDetailsPatch$Json$Xml$Params, context?: HttpContext): Observable<ModelsCustomerCustomerDetailsResponse> {
    return this.v3CustomersMeDetailsPatch$Json$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>): ModelsCustomerCustomerDetailsResponse => r.body)
    );
  }

  /**
   * SaveCustomerSettings.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeDetailsPatch$Xml$Plain()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3CustomersMeDetailsPatch$Xml$Plain$Response(params?: V3CustomersMeDetailsPatch$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>> {
    return v3CustomersMeDetailsPatch$Xml$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * SaveCustomerSettings.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeDetailsPatch$Xml$Plain$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3CustomersMeDetailsPatch$Xml$Plain(params?: V3CustomersMeDetailsPatch$Xml$Plain$Params, context?: HttpContext): Observable<ModelsCustomerCustomerDetailsResponse> {
    return this.v3CustomersMeDetailsPatch$Xml$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>): ModelsCustomerCustomerDetailsResponse => r.body)
    );
  }

  /**
   * SaveCustomerSettings.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeDetailsPatch$Xml$Json()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3CustomersMeDetailsPatch$Xml$Json$Response(params?: V3CustomersMeDetailsPatch$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>> {
    return v3CustomersMeDetailsPatch$Xml$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * SaveCustomerSettings.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeDetailsPatch$Xml$Json$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3CustomersMeDetailsPatch$Xml$Json(params?: V3CustomersMeDetailsPatch$Xml$Json$Params, context?: HttpContext): Observable<ModelsCustomerCustomerDetailsResponse> {
    return this.v3CustomersMeDetailsPatch$Xml$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>): ModelsCustomerCustomerDetailsResponse => r.body)
    );
  }

  /**
   * SaveCustomerSettings.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeDetailsPatch$Xml$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3CustomersMeDetailsPatch$Xml$Xml$Response(params?: V3CustomersMeDetailsPatch$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>> {
    return v3CustomersMeDetailsPatch$Xml$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * SaveCustomerSettings.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeDetailsPatch$Xml$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3CustomersMeDetailsPatch$Xml$Xml(params?: V3CustomersMeDetailsPatch$Xml$Xml$Params, context?: HttpContext): Observable<ModelsCustomerCustomerDetailsResponse> {
    return this.v3CustomersMeDetailsPatch$Xml$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>): ModelsCustomerCustomerDetailsResponse => r.body)
    );
  }

  /** Path part for operation `v3CustomersMeDetailsOtpGet()` */
  static readonly V3CustomersMeDetailsOtpGetPath = '/v3/customers/me/details-otp';

  /**
   * GenerateContactMethodOtp.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeDetailsOtpGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeDetailsOtpGet$Plain$Response(params?: V3CustomersMeDetailsOtpGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthOtpResponse>> {
    return v3CustomersMeDetailsOtpGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * GenerateContactMethodOtp.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeDetailsOtpGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeDetailsOtpGet$Plain(params?: V3CustomersMeDetailsOtpGet$Plain$Params, context?: HttpContext): Observable<ModelsAuthenticationAuthOtpResponse> {
    return this.v3CustomersMeDetailsOtpGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsAuthenticationAuthOtpResponse>): ModelsAuthenticationAuthOtpResponse => r.body)
    );
  }

  /**
   * GenerateContactMethodOtp.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeDetailsOtpGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeDetailsOtpGet$Json$Response(params?: V3CustomersMeDetailsOtpGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthOtpResponse>> {
    return v3CustomersMeDetailsOtpGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * GenerateContactMethodOtp.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeDetailsOtpGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeDetailsOtpGet$Json(params?: V3CustomersMeDetailsOtpGet$Json$Params, context?: HttpContext): Observable<ModelsAuthenticationAuthOtpResponse> {
    return this.v3CustomersMeDetailsOtpGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsAuthenticationAuthOtpResponse>): ModelsAuthenticationAuthOtpResponse => r.body)
    );
  }

  /**
   * GenerateContactMethodOtp.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeDetailsOtpGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeDetailsOtpGet$Xml$Response(params?: V3CustomersMeDetailsOtpGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthOtpResponse>> {
    return v3CustomersMeDetailsOtpGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * GenerateContactMethodOtp.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeDetailsOtpGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeDetailsOtpGet$Xml(params?: V3CustomersMeDetailsOtpGet$Xml$Params, context?: HttpContext): Observable<ModelsAuthenticationAuthOtpResponse> {
    return this.v3CustomersMeDetailsOtpGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsAuthenticationAuthOtpResponse>): ModelsAuthenticationAuthOtpResponse => r.body)
    );
  }

  /** Path part for operation `v3CustomersMeAccountsAccountNumberGet()` */
  static readonly V3CustomersMeAccountsAccountNumberGetPath = '/v3/customers/me/accounts/{accountNumber}';

  /**
   * Gets the accounts belonging to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeAccountsAccountNumberGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeAccountsAccountNumberGet$Plain$Response(params: V3CustomersMeAccountsAccountNumberGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerAccountsResponse>> {
    return v3CustomersMeAccountsAccountNumberGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the accounts belonging to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeAccountsAccountNumberGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeAccountsAccountNumberGet$Plain(params: V3CustomersMeAccountsAccountNumberGet$Plain$Params, context?: HttpContext): Observable<ModelsCustomerCustomerAccountsResponse> {
    return this.v3CustomersMeAccountsAccountNumberGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerAccountsResponse>): ModelsCustomerCustomerAccountsResponse => r.body)
    );
  }

  /**
   * Gets the accounts belonging to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeAccountsAccountNumberGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeAccountsAccountNumberGet$Json$Response(params: V3CustomersMeAccountsAccountNumberGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerAccountsResponse>> {
    return v3CustomersMeAccountsAccountNumberGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the accounts belonging to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeAccountsAccountNumberGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeAccountsAccountNumberGet$Json(params: V3CustomersMeAccountsAccountNumberGet$Json$Params, context?: HttpContext): Observable<ModelsCustomerCustomerAccountsResponse> {
    return this.v3CustomersMeAccountsAccountNumberGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerAccountsResponse>): ModelsCustomerCustomerAccountsResponse => r.body)
    );
  }

  /**
   * Gets the accounts belonging to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeAccountsAccountNumberGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeAccountsAccountNumberGet$Xml$Response(params: V3CustomersMeAccountsAccountNumberGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerAccountsResponse>> {
    return v3CustomersMeAccountsAccountNumberGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the accounts belonging to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeAccountsAccountNumberGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeAccountsAccountNumberGet$Xml(params: V3CustomersMeAccountsAccountNumberGet$Xml$Params, context?: HttpContext): Observable<ModelsCustomerCustomerAccountsResponse> {
    return this.v3CustomersMeAccountsAccountNumberGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerAccountsResponse>): ModelsCustomerCustomerAccountsResponse => r.body)
    );
  }

  /** Path part for operation `v3CustomersMePaymentsGet()` */
  static readonly V3CustomersMePaymentsGetPath = '/v3/customers/me/payments';

  /**
   * Gets the scheduled payments belonging to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMePaymentsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMePaymentsGet$Plain$Response(params?: V3CustomersMePaymentsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerScheduledPaymentsResponse>> {
    return v3CustomersMePaymentsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the scheduled payments belonging to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMePaymentsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMePaymentsGet$Plain(params?: V3CustomersMePaymentsGet$Plain$Params, context?: HttpContext): Observable<ModelsCustomerCustomerScheduledPaymentsResponse> {
    return this.v3CustomersMePaymentsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerScheduledPaymentsResponse>): ModelsCustomerCustomerScheduledPaymentsResponse => r.body)
    );
  }

  /**
   * Gets the scheduled payments belonging to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMePaymentsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMePaymentsGet$Json$Response(params?: V3CustomersMePaymentsGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerScheduledPaymentsResponse>> {
    return v3CustomersMePaymentsGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the scheduled payments belonging to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMePaymentsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMePaymentsGet$Json(params?: V3CustomersMePaymentsGet$Json$Params, context?: HttpContext): Observable<ModelsCustomerCustomerScheduledPaymentsResponse> {
    return this.v3CustomersMePaymentsGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerScheduledPaymentsResponse>): ModelsCustomerCustomerScheduledPaymentsResponse => r.body)
    );
  }

  /**
   * Gets the scheduled payments belonging to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMePaymentsGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMePaymentsGet$Xml$Response(params?: V3CustomersMePaymentsGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerScheduledPaymentsResponse>> {
    return v3CustomersMePaymentsGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the scheduled payments belonging to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMePaymentsGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMePaymentsGet$Xml(params?: V3CustomersMePaymentsGet$Xml$Params, context?: HttpContext): Observable<ModelsCustomerCustomerScheduledPaymentsResponse> {
    return this.v3CustomersMePaymentsGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerScheduledPaymentsResponse>): ModelsCustomerCustomerScheduledPaymentsResponse => r.body)
    );
  }

  /** Path part for operation `v3CustomersMeAccountsAccountNumberPaymentsGet()` */
  static readonly V3CustomersMeAccountsAccountNumberPaymentsGetPath = '/v3/customers/me/accounts/{accountNumber}/payments';

  /**
   * Gets the scheduled payments belonging to the specified account for the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeAccountsAccountNumberPaymentsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeAccountsAccountNumberPaymentsGet$Plain$Response(params: V3CustomersMeAccountsAccountNumberPaymentsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerScheduledPaymentsResponse>> {
    return v3CustomersMeAccountsAccountNumberPaymentsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the scheduled payments belonging to the specified account for the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeAccountsAccountNumberPaymentsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeAccountsAccountNumberPaymentsGet$Plain(params: V3CustomersMeAccountsAccountNumberPaymentsGet$Plain$Params, context?: HttpContext): Observable<ModelsCustomerCustomerScheduledPaymentsResponse> {
    return this.v3CustomersMeAccountsAccountNumberPaymentsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerScheduledPaymentsResponse>): ModelsCustomerCustomerScheduledPaymentsResponse => r.body)
    );
  }

  /**
   * Gets the scheduled payments belonging to the specified account for the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeAccountsAccountNumberPaymentsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeAccountsAccountNumberPaymentsGet$Json$Response(params: V3CustomersMeAccountsAccountNumberPaymentsGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerScheduledPaymentsResponse>> {
    return v3CustomersMeAccountsAccountNumberPaymentsGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the scheduled payments belonging to the specified account for the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeAccountsAccountNumberPaymentsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeAccountsAccountNumberPaymentsGet$Json(params: V3CustomersMeAccountsAccountNumberPaymentsGet$Json$Params, context?: HttpContext): Observable<ModelsCustomerCustomerScheduledPaymentsResponse> {
    return this.v3CustomersMeAccountsAccountNumberPaymentsGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerScheduledPaymentsResponse>): ModelsCustomerCustomerScheduledPaymentsResponse => r.body)
    );
  }

  /**
   * Gets the scheduled payments belonging to the specified account for the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeAccountsAccountNumberPaymentsGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeAccountsAccountNumberPaymentsGet$Xml$Response(params: V3CustomersMeAccountsAccountNumberPaymentsGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerScheduledPaymentsResponse>> {
    return v3CustomersMeAccountsAccountNumberPaymentsGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the scheduled payments belonging to the specified account for the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeAccountsAccountNumberPaymentsGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeAccountsAccountNumberPaymentsGet$Xml(params: V3CustomersMeAccountsAccountNumberPaymentsGet$Xml$Params, context?: HttpContext): Observable<ModelsCustomerCustomerScheduledPaymentsResponse> {
    return this.v3CustomersMeAccountsAccountNumberPaymentsGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerScheduledPaymentsResponse>): ModelsCustomerCustomerScheduledPaymentsResponse => r.body)
    );
  }

  /** Path part for operation `v3CustomersMeEnquiryPost()` */
  static readonly V3CustomersMeEnquiryPostPath = '/v3/customers/me/enquiry';

  /**
   * Sends an enquiry.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeEnquiryPost$Json$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3CustomersMeEnquiryPost$Json$Plain$Response(params?: V3CustomersMeEnquiryPost$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerEnquiry>> {
    return v3CustomersMeEnquiryPost$Json$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Sends an enquiry.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeEnquiryPost$Json$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3CustomersMeEnquiryPost$Json$Plain(params?: V3CustomersMeEnquiryPost$Json$Plain$Params, context?: HttpContext): Observable<ModelsCustomerCustomerEnquiry> {
    return this.v3CustomersMeEnquiryPost$Json$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerEnquiry>): ModelsCustomerCustomerEnquiry => r.body)
    );
  }

  /**
   * Sends an enquiry.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeEnquiryPost$Json$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3CustomersMeEnquiryPost$Json$Json$Response(params?: V3CustomersMeEnquiryPost$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerEnquiry>> {
    return v3CustomersMeEnquiryPost$Json$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Sends an enquiry.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeEnquiryPost$Json$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3CustomersMeEnquiryPost$Json$Json(params?: V3CustomersMeEnquiryPost$Json$Json$Params, context?: HttpContext): Observable<ModelsCustomerCustomerEnquiry> {
    return this.v3CustomersMeEnquiryPost$Json$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerEnquiry>): ModelsCustomerCustomerEnquiry => r.body)
    );
  }

  /**
   * Sends an enquiry.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeEnquiryPost$Json$Xml()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3CustomersMeEnquiryPost$Json$Xml$Response(params?: V3CustomersMeEnquiryPost$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerEnquiry>> {
    return v3CustomersMeEnquiryPost$Json$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Sends an enquiry.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeEnquiryPost$Json$Xml$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3CustomersMeEnquiryPost$Json$Xml(params?: V3CustomersMeEnquiryPost$Json$Xml$Params, context?: HttpContext): Observable<ModelsCustomerCustomerEnquiry> {
    return this.v3CustomersMeEnquiryPost$Json$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerEnquiry>): ModelsCustomerCustomerEnquiry => r.body)
    );
  }

  /**
   * Sends an enquiry.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeEnquiryPost$Xml$Plain()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3CustomersMeEnquiryPost$Xml$Plain$Response(params?: V3CustomersMeEnquiryPost$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerEnquiry>> {
    return v3CustomersMeEnquiryPost$Xml$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Sends an enquiry.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeEnquiryPost$Xml$Plain$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3CustomersMeEnquiryPost$Xml$Plain(params?: V3CustomersMeEnquiryPost$Xml$Plain$Params, context?: HttpContext): Observable<ModelsCustomerCustomerEnquiry> {
    return this.v3CustomersMeEnquiryPost$Xml$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerEnquiry>): ModelsCustomerCustomerEnquiry => r.body)
    );
  }

  /**
   * Sends an enquiry.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeEnquiryPost$Xml$Json()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3CustomersMeEnquiryPost$Xml$Json$Response(params?: V3CustomersMeEnquiryPost$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerEnquiry>> {
    return v3CustomersMeEnquiryPost$Xml$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Sends an enquiry.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeEnquiryPost$Xml$Json$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3CustomersMeEnquiryPost$Xml$Json(params?: V3CustomersMeEnquiryPost$Xml$Json$Params, context?: HttpContext): Observable<ModelsCustomerCustomerEnquiry> {
    return this.v3CustomersMeEnquiryPost$Xml$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerEnquiry>): ModelsCustomerCustomerEnquiry => r.body)
    );
  }

  /**
   * Sends an enquiry.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeEnquiryPost$Xml$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3CustomersMeEnquiryPost$Xml$Xml$Response(params?: V3CustomersMeEnquiryPost$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerEnquiry>> {
    return v3CustomersMeEnquiryPost$Xml$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Sends an enquiry.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeEnquiryPost$Xml$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3CustomersMeEnquiryPost$Xml$Xml(params?: V3CustomersMeEnquiryPost$Xml$Xml$Params, context?: HttpContext): Observable<ModelsCustomerCustomerEnquiry> {
    return this.v3CustomersMeEnquiryPost$Xml$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerEnquiry>): ModelsCustomerCustomerEnquiry => r.body)
    );
  }

  /** Path part for operation `v3CustomersMeNotificationsGet()` */
  static readonly V3CustomersMeNotificationsGetPath = '/v3/customers/me/notifications';

  /**
   * Gets the notifications applicable to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeNotificationsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeNotificationsGet$Plain$Response(params?: V3CustomersMeNotificationsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerNotificationsResponse>> {
    return v3CustomersMeNotificationsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the notifications applicable to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeNotificationsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeNotificationsGet$Plain(params?: V3CustomersMeNotificationsGet$Plain$Params, context?: HttpContext): Observable<ModelsCustomerCustomerNotificationsResponse> {
    return this.v3CustomersMeNotificationsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerNotificationsResponse>): ModelsCustomerCustomerNotificationsResponse => r.body)
    );
  }

  /**
   * Gets the notifications applicable to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeNotificationsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeNotificationsGet$Json$Response(params?: V3CustomersMeNotificationsGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerNotificationsResponse>> {
    return v3CustomersMeNotificationsGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the notifications applicable to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeNotificationsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeNotificationsGet$Json(params?: V3CustomersMeNotificationsGet$Json$Params, context?: HttpContext): Observable<ModelsCustomerCustomerNotificationsResponse> {
    return this.v3CustomersMeNotificationsGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerNotificationsResponse>): ModelsCustomerCustomerNotificationsResponse => r.body)
    );
  }

  /**
   * Gets the notifications applicable to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeNotificationsGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeNotificationsGet$Xml$Response(params?: V3CustomersMeNotificationsGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerNotificationsResponse>> {
    return v3CustomersMeNotificationsGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the notifications applicable to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeNotificationsGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeNotificationsGet$Xml(params?: V3CustomersMeNotificationsGet$Xml$Params, context?: HttpContext): Observable<ModelsCustomerCustomerNotificationsResponse> {
    return this.v3CustomersMeNotificationsGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerNotificationsResponse>): ModelsCustomerCustomerNotificationsResponse => r.body)
    );
  }

  /** Path part for operation `v3CustomersMeNotificationsPatch()` */
  static readonly V3CustomersMeNotificationsPatchPath = '/v3/customers/me/notifications';

  /**
   * Mark all as read.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeNotificationsPatch$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeNotificationsPatch$Plain$Response(params?: V3CustomersMeNotificationsPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return v3CustomersMeNotificationsPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Mark all as read.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeNotificationsPatch$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeNotificationsPatch$Plain(params?: V3CustomersMeNotificationsPatch$Plain$Params, context?: HttpContext): Observable<boolean> {
    return this.v3CustomersMeNotificationsPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /**
   * Mark all as read.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeNotificationsPatch$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeNotificationsPatch$Json$Response(params?: V3CustomersMeNotificationsPatch$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return v3CustomersMeNotificationsPatch$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Mark all as read.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeNotificationsPatch$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeNotificationsPatch$Json(params?: V3CustomersMeNotificationsPatch$Json$Params, context?: HttpContext): Observable<boolean> {
    return this.v3CustomersMeNotificationsPatch$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /**
   * Mark all as read.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeNotificationsPatch$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeNotificationsPatch$Xml$Response(params?: V3CustomersMeNotificationsPatch$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return v3CustomersMeNotificationsPatch$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Mark all as read.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeNotificationsPatch$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeNotificationsPatch$Xml(params?: V3CustomersMeNotificationsPatch$Xml$Params, context?: HttpContext): Observable<boolean> {
    return this.v3CustomersMeNotificationsPatch$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `v3CustomersMeNotificationsNotificationIdGet()` */
  static readonly V3CustomersMeNotificationsNotificationIdGetPath = '/v3/customers/me/notifications/{notificationId}';

  /**
   * Gets the notification for a given notificationId.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeNotificationsNotificationIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeNotificationsNotificationIdGet$Plain$Response(params: V3CustomersMeNotificationsNotificationIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerNotificationResponse>> {
    return v3CustomersMeNotificationsNotificationIdGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the notification for a given notificationId.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeNotificationsNotificationIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeNotificationsNotificationIdGet$Plain(params: V3CustomersMeNotificationsNotificationIdGet$Plain$Params, context?: HttpContext): Observable<ModelsCustomerCustomerNotificationResponse> {
    return this.v3CustomersMeNotificationsNotificationIdGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerNotificationResponse>): ModelsCustomerCustomerNotificationResponse => r.body)
    );
  }

  /**
   * Gets the notification for a given notificationId.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeNotificationsNotificationIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeNotificationsNotificationIdGet$Json$Response(params: V3CustomersMeNotificationsNotificationIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerNotificationResponse>> {
    return v3CustomersMeNotificationsNotificationIdGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the notification for a given notificationId.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeNotificationsNotificationIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeNotificationsNotificationIdGet$Json(params: V3CustomersMeNotificationsNotificationIdGet$Json$Params, context?: HttpContext): Observable<ModelsCustomerCustomerNotificationResponse> {
    return this.v3CustomersMeNotificationsNotificationIdGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerNotificationResponse>): ModelsCustomerCustomerNotificationResponse => r.body)
    );
  }

  /**
   * Gets the notification for a given notificationId.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeNotificationsNotificationIdGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeNotificationsNotificationIdGet$Xml$Response(params: V3CustomersMeNotificationsNotificationIdGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerNotificationResponse>> {
    return v3CustomersMeNotificationsNotificationIdGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the notification for a given notificationId.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeNotificationsNotificationIdGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeNotificationsNotificationIdGet$Xml(params: V3CustomersMeNotificationsNotificationIdGet$Xml$Params, context?: HttpContext): Observable<ModelsCustomerCustomerNotificationResponse> {
    return this.v3CustomersMeNotificationsNotificationIdGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerNotificationResponse>): ModelsCustomerCustomerNotificationResponse => r.body)
    );
  }

  /** Path part for operation `v3CustomersMeNotificationsNotificationIdDelete()` */
  static readonly V3CustomersMeNotificationsNotificationIdDeletePath = '/v3/customers/me/notifications/{notificationId}';

  /**
   * Saves the read status for notification.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeNotificationsNotificationIdDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeNotificationsNotificationIdDelete$Plain$Response(params: V3CustomersMeNotificationsNotificationIdDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return v3CustomersMeNotificationsNotificationIdDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Saves the read status for notification.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeNotificationsNotificationIdDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeNotificationsNotificationIdDelete$Plain(params: V3CustomersMeNotificationsNotificationIdDelete$Plain$Params, context?: HttpContext): Observable<boolean> {
    return this.v3CustomersMeNotificationsNotificationIdDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /**
   * Saves the read status for notification.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeNotificationsNotificationIdDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeNotificationsNotificationIdDelete$Json$Response(params: V3CustomersMeNotificationsNotificationIdDelete$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return v3CustomersMeNotificationsNotificationIdDelete$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Saves the read status for notification.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeNotificationsNotificationIdDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeNotificationsNotificationIdDelete$Json(params: V3CustomersMeNotificationsNotificationIdDelete$Json$Params, context?: HttpContext): Observable<boolean> {
    return this.v3CustomersMeNotificationsNotificationIdDelete$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /**
   * Saves the read status for notification.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeNotificationsNotificationIdDelete$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeNotificationsNotificationIdDelete$Xml$Response(params: V3CustomersMeNotificationsNotificationIdDelete$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return v3CustomersMeNotificationsNotificationIdDelete$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Saves the read status for notification.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeNotificationsNotificationIdDelete$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeNotificationsNotificationIdDelete$Xml(params: V3CustomersMeNotificationsNotificationIdDelete$Xml$Params, context?: HttpContext): Observable<boolean> {
    return this.v3CustomersMeNotificationsNotificationIdDelete$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `v3CustomersMeNotificationsUnreadGet()` */
  static readonly V3CustomersMeNotificationsUnreadGetPath = '/v3/customers/me/notifications/unread';

  /**
   * Gets the notifications count applicable to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeNotificationsUnreadGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeNotificationsUnreadGet$Plain$Response(params?: V3CustomersMeNotificationsUnreadGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return v3CustomersMeNotificationsUnreadGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the notifications count applicable to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeNotificationsUnreadGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeNotificationsUnreadGet$Plain(params?: V3CustomersMeNotificationsUnreadGet$Plain$Params, context?: HttpContext): Observable<number> {
    return this.v3CustomersMeNotificationsUnreadGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /**
   * Gets the notifications count applicable to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeNotificationsUnreadGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeNotificationsUnreadGet$Json$Response(params?: V3CustomersMeNotificationsUnreadGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return v3CustomersMeNotificationsUnreadGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the notifications count applicable to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeNotificationsUnreadGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeNotificationsUnreadGet$Json(params?: V3CustomersMeNotificationsUnreadGet$Json$Params, context?: HttpContext): Observable<number> {
    return this.v3CustomersMeNotificationsUnreadGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /**
   * Gets the notifications count applicable to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeNotificationsUnreadGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeNotificationsUnreadGet$Xml$Response(params?: V3CustomersMeNotificationsUnreadGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return v3CustomersMeNotificationsUnreadGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the notifications count applicable to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeNotificationsUnreadGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeNotificationsUnreadGet$Xml(params?: V3CustomersMeNotificationsUnreadGet$Xml$Params, context?: HttpContext): Observable<number> {
    return this.v3CustomersMeNotificationsUnreadGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /** Path part for operation `v3CustomersMeNotificationsNotificationIdReadStatusPatch()` */
  static readonly V3CustomersMeNotificationsNotificationIdReadStatusPatchPath = '/v3/customers/me/notifications/{notificationId}/{readStatus}';

  /**
   * Saves the read status for notification.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeNotificationsNotificationIdReadStatusPatch$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeNotificationsNotificationIdReadStatusPatch$Plain$Response(params: V3CustomersMeNotificationsNotificationIdReadStatusPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerNotification>> {
    return v3CustomersMeNotificationsNotificationIdReadStatusPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Saves the read status for notification.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeNotificationsNotificationIdReadStatusPatch$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeNotificationsNotificationIdReadStatusPatch$Plain(params: V3CustomersMeNotificationsNotificationIdReadStatusPatch$Plain$Params, context?: HttpContext): Observable<ModelsCustomerCustomerNotification> {
    return this.v3CustomersMeNotificationsNotificationIdReadStatusPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerNotification>): ModelsCustomerCustomerNotification => r.body)
    );
  }

  /**
   * Saves the read status for notification.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeNotificationsNotificationIdReadStatusPatch$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeNotificationsNotificationIdReadStatusPatch$Json$Response(params: V3CustomersMeNotificationsNotificationIdReadStatusPatch$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerNotification>> {
    return v3CustomersMeNotificationsNotificationIdReadStatusPatch$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Saves the read status for notification.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeNotificationsNotificationIdReadStatusPatch$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeNotificationsNotificationIdReadStatusPatch$Json(params: V3CustomersMeNotificationsNotificationIdReadStatusPatch$Json$Params, context?: HttpContext): Observable<ModelsCustomerCustomerNotification> {
    return this.v3CustomersMeNotificationsNotificationIdReadStatusPatch$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerNotification>): ModelsCustomerCustomerNotification => r.body)
    );
  }

  /**
   * Saves the read status for notification.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeNotificationsNotificationIdReadStatusPatch$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeNotificationsNotificationIdReadStatusPatch$Xml$Response(params: V3CustomersMeNotificationsNotificationIdReadStatusPatch$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerNotification>> {
    return v3CustomersMeNotificationsNotificationIdReadStatusPatch$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Saves the read status for notification.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeNotificationsNotificationIdReadStatusPatch$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeNotificationsNotificationIdReadStatusPatch$Xml(params: V3CustomersMeNotificationsNotificationIdReadStatusPatch$Xml$Params, context?: HttpContext): Observable<ModelsCustomerCustomerNotification> {
    return this.v3CustomersMeNotificationsNotificationIdReadStatusPatch$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerNotification>): ModelsCustomerCustomerNotification => r.body)
    );
  }

  /** Path part for operation `v3CustomersMeOnlinePaymentsGet()` */
  static readonly V3CustomersMeOnlinePaymentsGetPath = '/v3/customers/me/online-payments';

  /**
   * Gets the online payments belonging to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeOnlinePaymentsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeOnlinePaymentsGet$Plain$Response(params?: V3CustomersMeOnlinePaymentsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentsResponse>> {
    return v3CustomersMeOnlinePaymentsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the online payments belonging to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeOnlinePaymentsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeOnlinePaymentsGet$Plain(params?: V3CustomersMeOnlinePaymentsGet$Plain$Params, context?: HttpContext): Observable<ModelsCustomerCustomerOnlinePaymentsResponse> {
    return this.v3CustomersMeOnlinePaymentsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentsResponse>): ModelsCustomerCustomerOnlinePaymentsResponse => r.body)
    );
  }

  /**
   * Gets the online payments belonging to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeOnlinePaymentsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeOnlinePaymentsGet$Json$Response(params?: V3CustomersMeOnlinePaymentsGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentsResponse>> {
    return v3CustomersMeOnlinePaymentsGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the online payments belonging to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeOnlinePaymentsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeOnlinePaymentsGet$Json(params?: V3CustomersMeOnlinePaymentsGet$Json$Params, context?: HttpContext): Observable<ModelsCustomerCustomerOnlinePaymentsResponse> {
    return this.v3CustomersMeOnlinePaymentsGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentsResponse>): ModelsCustomerCustomerOnlinePaymentsResponse => r.body)
    );
  }

  /**
   * Gets the online payments belonging to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeOnlinePaymentsGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeOnlinePaymentsGet$Xml$Response(params?: V3CustomersMeOnlinePaymentsGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentsResponse>> {
    return v3CustomersMeOnlinePaymentsGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the online payments belonging to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeOnlinePaymentsGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeOnlinePaymentsGet$Xml(params?: V3CustomersMeOnlinePaymentsGet$Xml$Params, context?: HttpContext): Observable<ModelsCustomerCustomerOnlinePaymentsResponse> {
    return this.v3CustomersMeOnlinePaymentsGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentsResponse>): ModelsCustomerCustomerOnlinePaymentsResponse => r.body)
    );
  }

  /** Path part for operation `v3CustomersMeOnlinePaymentsPost()` */
  static readonly V3CustomersMeOnlinePaymentsPostPath = '/v3/customers/me/online-payments';

  /**
   * Creates a payment.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeOnlinePaymentsPost$Json$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3CustomersMeOnlinePaymentsPost$Json$Plain$Response(params?: V3CustomersMeOnlinePaymentsPost$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentResponse>> {
    return v3CustomersMeOnlinePaymentsPost$Json$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a payment.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeOnlinePaymentsPost$Json$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3CustomersMeOnlinePaymentsPost$Json$Plain(params?: V3CustomersMeOnlinePaymentsPost$Json$Plain$Params, context?: HttpContext): Observable<ModelsCustomerCustomerOnlinePaymentResponse> {
    return this.v3CustomersMeOnlinePaymentsPost$Json$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentResponse>): ModelsCustomerCustomerOnlinePaymentResponse => r.body)
    );
  }

  /**
   * Creates a payment.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeOnlinePaymentsPost$Json$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3CustomersMeOnlinePaymentsPost$Json$Json$Response(params?: V3CustomersMeOnlinePaymentsPost$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentResponse>> {
    return v3CustomersMeOnlinePaymentsPost$Json$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a payment.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeOnlinePaymentsPost$Json$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3CustomersMeOnlinePaymentsPost$Json$Json(params?: V3CustomersMeOnlinePaymentsPost$Json$Json$Params, context?: HttpContext): Observable<ModelsCustomerCustomerOnlinePaymentResponse> {
    return this.v3CustomersMeOnlinePaymentsPost$Json$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentResponse>): ModelsCustomerCustomerOnlinePaymentResponse => r.body)
    );
  }

  /**
   * Creates a payment.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeOnlinePaymentsPost$Json$Xml()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3CustomersMeOnlinePaymentsPost$Json$Xml$Response(params?: V3CustomersMeOnlinePaymentsPost$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentResponse>> {
    return v3CustomersMeOnlinePaymentsPost$Json$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a payment.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeOnlinePaymentsPost$Json$Xml$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3CustomersMeOnlinePaymentsPost$Json$Xml(params?: V3CustomersMeOnlinePaymentsPost$Json$Xml$Params, context?: HttpContext): Observable<ModelsCustomerCustomerOnlinePaymentResponse> {
    return this.v3CustomersMeOnlinePaymentsPost$Json$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentResponse>): ModelsCustomerCustomerOnlinePaymentResponse => r.body)
    );
  }

  /**
   * Creates a payment.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeOnlinePaymentsPost$Xml$Plain()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3CustomersMeOnlinePaymentsPost$Xml$Plain$Response(params?: V3CustomersMeOnlinePaymentsPost$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentResponse>> {
    return v3CustomersMeOnlinePaymentsPost$Xml$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a payment.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeOnlinePaymentsPost$Xml$Plain$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3CustomersMeOnlinePaymentsPost$Xml$Plain(params?: V3CustomersMeOnlinePaymentsPost$Xml$Plain$Params, context?: HttpContext): Observable<ModelsCustomerCustomerOnlinePaymentResponse> {
    return this.v3CustomersMeOnlinePaymentsPost$Xml$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentResponse>): ModelsCustomerCustomerOnlinePaymentResponse => r.body)
    );
  }

  /**
   * Creates a payment.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeOnlinePaymentsPost$Xml$Json()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3CustomersMeOnlinePaymentsPost$Xml$Json$Response(params?: V3CustomersMeOnlinePaymentsPost$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentResponse>> {
    return v3CustomersMeOnlinePaymentsPost$Xml$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a payment.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeOnlinePaymentsPost$Xml$Json$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3CustomersMeOnlinePaymentsPost$Xml$Json(params?: V3CustomersMeOnlinePaymentsPost$Xml$Json$Params, context?: HttpContext): Observable<ModelsCustomerCustomerOnlinePaymentResponse> {
    return this.v3CustomersMeOnlinePaymentsPost$Xml$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentResponse>): ModelsCustomerCustomerOnlinePaymentResponse => r.body)
    );
  }

  /**
   * Creates a payment.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeOnlinePaymentsPost$Xml$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3CustomersMeOnlinePaymentsPost$Xml$Xml$Response(params?: V3CustomersMeOnlinePaymentsPost$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentResponse>> {
    return v3CustomersMeOnlinePaymentsPost$Xml$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a payment.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeOnlinePaymentsPost$Xml$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3CustomersMeOnlinePaymentsPost$Xml$Xml(params?: V3CustomersMeOnlinePaymentsPost$Xml$Xml$Params, context?: HttpContext): Observable<ModelsCustomerCustomerOnlinePaymentResponse> {
    return this.v3CustomersMeOnlinePaymentsPost$Xml$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentResponse>): ModelsCustomerCustomerOnlinePaymentResponse => r.body)
    );
  }

  /** Path part for operation `v3CustomersMeOnlinePaymentsIdGet()` */
  static readonly V3CustomersMeOnlinePaymentsIdGetPath = '/v3/customers/me/online-payments/{id}';

  /**
   * Gets the online payments belonging to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeOnlinePaymentsIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeOnlinePaymentsIdGet$Plain$Response(params: V3CustomersMeOnlinePaymentsIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentResponse>> {
    return v3CustomersMeOnlinePaymentsIdGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the online payments belonging to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeOnlinePaymentsIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeOnlinePaymentsIdGet$Plain(params: V3CustomersMeOnlinePaymentsIdGet$Plain$Params, context?: HttpContext): Observable<ModelsCustomerCustomerOnlinePaymentResponse> {
    return this.v3CustomersMeOnlinePaymentsIdGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentResponse>): ModelsCustomerCustomerOnlinePaymentResponse => r.body)
    );
  }

  /**
   * Gets the online payments belonging to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeOnlinePaymentsIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeOnlinePaymentsIdGet$Json$Response(params: V3CustomersMeOnlinePaymentsIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentResponse>> {
    return v3CustomersMeOnlinePaymentsIdGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the online payments belonging to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeOnlinePaymentsIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeOnlinePaymentsIdGet$Json(params: V3CustomersMeOnlinePaymentsIdGet$Json$Params, context?: HttpContext): Observable<ModelsCustomerCustomerOnlinePaymentResponse> {
    return this.v3CustomersMeOnlinePaymentsIdGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentResponse>): ModelsCustomerCustomerOnlinePaymentResponse => r.body)
    );
  }

  /**
   * Gets the online payments belonging to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeOnlinePaymentsIdGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeOnlinePaymentsIdGet$Xml$Response(params: V3CustomersMeOnlinePaymentsIdGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentResponse>> {
    return v3CustomersMeOnlinePaymentsIdGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the online payments belonging to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeOnlinePaymentsIdGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeOnlinePaymentsIdGet$Xml(params: V3CustomersMeOnlinePaymentsIdGet$Xml$Params, context?: HttpContext): Observable<ModelsCustomerCustomerOnlinePaymentResponse> {
    return this.v3CustomersMeOnlinePaymentsIdGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentResponse>): ModelsCustomerCustomerOnlinePaymentResponse => r.body)
    );
  }

  /** Path part for operation `v3CustomersMeOnlinePaymentsIdStatusGet()` */
  static readonly V3CustomersMeOnlinePaymentsIdStatusGetPath = '/v3/customers/me/online-payments/{id}/status';

  /**
   * Gets the online payments belonging to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeOnlinePaymentsIdStatusGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeOnlinePaymentsIdStatusGet$Plain$Response(params: V3CustomersMeOnlinePaymentsIdStatusGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerEnumsCustomerOnlinePaymentStatusEnum>> {
    return v3CustomersMeOnlinePaymentsIdStatusGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the online payments belonging to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeOnlinePaymentsIdStatusGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeOnlinePaymentsIdStatusGet$Plain(params: V3CustomersMeOnlinePaymentsIdStatusGet$Plain$Params, context?: HttpContext): Observable<ModelsCustomerEnumsCustomerOnlinePaymentStatusEnum> {
    return this.v3CustomersMeOnlinePaymentsIdStatusGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerEnumsCustomerOnlinePaymentStatusEnum>): ModelsCustomerEnumsCustomerOnlinePaymentStatusEnum => r.body)
    );
  }

  /**
   * Gets the online payments belonging to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeOnlinePaymentsIdStatusGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeOnlinePaymentsIdStatusGet$Json$Response(params: V3CustomersMeOnlinePaymentsIdStatusGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerEnumsCustomerOnlinePaymentStatusEnum>> {
    return v3CustomersMeOnlinePaymentsIdStatusGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the online payments belonging to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeOnlinePaymentsIdStatusGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeOnlinePaymentsIdStatusGet$Json(params: V3CustomersMeOnlinePaymentsIdStatusGet$Json$Params, context?: HttpContext): Observable<ModelsCustomerEnumsCustomerOnlinePaymentStatusEnum> {
    return this.v3CustomersMeOnlinePaymentsIdStatusGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerEnumsCustomerOnlinePaymentStatusEnum>): ModelsCustomerEnumsCustomerOnlinePaymentStatusEnum => r.body)
    );
  }

  /**
   * Gets the online payments belonging to the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeOnlinePaymentsIdStatusGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeOnlinePaymentsIdStatusGet$Xml$Response(params: V3CustomersMeOnlinePaymentsIdStatusGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerEnumsCustomerOnlinePaymentStatusEnum>> {
    return v3CustomersMeOnlinePaymentsIdStatusGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the online payments belonging to the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeOnlinePaymentsIdStatusGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeOnlinePaymentsIdStatusGet$Xml(params: V3CustomersMeOnlinePaymentsIdStatusGet$Xml$Params, context?: HttpContext): Observable<ModelsCustomerEnumsCustomerOnlinePaymentStatusEnum> {
    return this.v3CustomersMeOnlinePaymentsIdStatusGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerEnumsCustomerOnlinePaymentStatusEnum>): ModelsCustomerEnumsCustomerOnlinePaymentStatusEnum => r.body)
    );
  }

  /** Path part for operation `v3CustomersMeOnlinePaymentTypesGet()` */
  static readonly V3CustomersMeOnlinePaymentTypesGetPath = '/v3/customers/me/online-payment-types';

  /**
   * Returns the list of payment types available for the customer.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeOnlinePaymentTypesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeOnlinePaymentTypesGet$Plain$Response(params?: V3CustomersMeOnlinePaymentTypesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentTypesResponse>> {
    return v3CustomersMeOnlinePaymentTypesGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns the list of payment types available for the customer.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeOnlinePaymentTypesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeOnlinePaymentTypesGet$Plain(params?: V3CustomersMeOnlinePaymentTypesGet$Plain$Params, context?: HttpContext): Observable<ModelsCustomerCustomerOnlinePaymentTypesResponse> {
    return this.v3CustomersMeOnlinePaymentTypesGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentTypesResponse>): ModelsCustomerCustomerOnlinePaymentTypesResponse => r.body)
    );
  }

  /**
   * Returns the list of payment types available for the customer.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeOnlinePaymentTypesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeOnlinePaymentTypesGet$Json$Response(params?: V3CustomersMeOnlinePaymentTypesGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentTypesResponse>> {
    return v3CustomersMeOnlinePaymentTypesGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns the list of payment types available for the customer.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeOnlinePaymentTypesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeOnlinePaymentTypesGet$Json(params?: V3CustomersMeOnlinePaymentTypesGet$Json$Params, context?: HttpContext): Observable<ModelsCustomerCustomerOnlinePaymentTypesResponse> {
    return this.v3CustomersMeOnlinePaymentTypesGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentTypesResponse>): ModelsCustomerCustomerOnlinePaymentTypesResponse => r.body)
    );
  }

  /**
   * Returns the list of payment types available for the customer.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3CustomersMeOnlinePaymentTypesGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeOnlinePaymentTypesGet$Xml$Response(params?: V3CustomersMeOnlinePaymentTypesGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentTypesResponse>> {
    return v3CustomersMeOnlinePaymentTypesGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns the list of payment types available for the customer.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3CustomersMeOnlinePaymentTypesGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3CustomersMeOnlinePaymentTypesGet$Xml(params?: V3CustomersMeOnlinePaymentTypesGet$Xml$Params, context?: HttpContext): Observable<ModelsCustomerCustomerOnlinePaymentTypesResponse> {
    return this.v3CustomersMeOnlinePaymentTypesGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentTypesResponse>): ModelsCustomerCustomerOnlinePaymentTypesResponse => r.body)
    );
  }

}
